import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, memoActionDel } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { TRATAMIENTO_DEBITO_AUTOMATICO_TYPE } from '../../consts/tratamientoDebitoAutomaticoType';
import { VALIDATION_MESSAGE } from '../../consts/validationMessage';
import { useEntidad, useForm, useLista, useNav, useFormErrors } from '../../components/hooks';
import { Loading, TableCustom, MessageModal, Modal, SectionHeading, InputCuenta, InputNumber, InputStaticEntidad, FormLabel, CheckboxButton, CheckboxButtonGroup, Select, FormError } from '../../components/common';
import { getFormatNumber, precisionRound, getDateToString } from '../../utils/convert';
import { CloneObject } from '../../utils/helpers';
import EmisionPlanPagoGrid from '../../components/controls/EmisionPlanPagoGrid';


function PlanPagoView() {

    //parametros url
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNav()

    const {cache} = useSelector( (state) => state.memo );

    const entityInit = {
        cuenta: {
            id: 0,
            numeroCuenta: '',
            numeroWeb: '',
            idEstadoCuenta: 0,
            idTipoTributo: 0,
            idTributo: 0,
            fechaAlta: null,
            fechaBaja: null,
            idContribuyentePrincipal: 0,
            idDireccionPrincipal: 0,
            idDireccionEntrega: 0
        },
        planPagoDefinicion: {
            id: 0,
            idEstadoPlanPagoDefinicion: 0,
            idTipoPlanPago: 0,
            idTipoTributo: 0,
            idTasaPlanPago: 0,
            idSubTasaPlanPago: 0,
            codigo: "",
            descripcion: "",
            fechaDesde: null,
            fechaHasta: null,
            cuotaDesde: 0,
            cuotaHasta: 0,
            periodicidad: 0,
            idTipoVencimientoAnticipo: 0,
            idTipoVencimientoCuota1: 0,
            idTipoVencimientoCuotas: 0,
            idTipoAlcanceTemporal: 0,
            fechaDesdeAlcanceTemporal: null,
            fechaHastaAlcanceTemporal: null,
            mesDesdeAlcanceTemporal: 0,
            mesHastaAlcanceTemporal: 0,
            aplicaDerechosEspontaneos: false,
            aplicaCancelacionAnticipada: false,
            aplicaTotalidadDeudaAdministrativa: false,
            aplicaDeudaAdministrativa: false,
            aplicaDeudaLegal: false,
            montoDeudaAdministrativaDesde: 0,
            montoDeudaAdministrativaHasta: 0,
            montoCuotaDesde: 0,
            montoCuotaHasta: 0,
            idTipoCalculoInteres: 0,
            idViaConsolidacion: 0,
            idTipoTratamientoPagos: 0,
            idTipoTratamientoDebitoAutomatico: 0,
            idUsuarioCreacion: 0,
            fechaCreacion: null,
            tipoPlanPago: {
                id: 0,
                codigo: '',
                nombre: '',
                idTipoTributo: 0,
                convenio: '',
                condiciones: '',
                firmas: ''
            }
        },
        opcionCuota: {
            numeroCuota: 0,
            cantidadCuotas: 0,
            importeCapital: 0,
            importeIntereses: 0,
            importeSellados: 0,
            importeAnticipo: 0,
            importeQuita: 0,
            importeCuota: 0
        }
    };

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        idPlanPago: 0,
        items: [],
        loading: false,
        showResumen: false,
        disbled: false
    });
    const [cuenta, setCuenta] = useState(entityInit.cuenta);
    const [planPagoDefinicion, setPlanPagoDefinicion] = useState(entityInit.planPagoDefinicion);
    const [definiciones, setDefiniciones] = useState([]);
    const [definicionesSinRelacion, setDefinicionesSinRelacion] = useState([]);
    const [tipoVinculoCuentaPermitidos, setTipoVinculoCuentaPermitidos] = useState([]);
    const [opcionCuotas, setOpcionCuotas] = useState([]);
    const [opcionCuotaSelected, setOpcionCuotaSelected] = useState(entityInit.opcionCuota);
    const [importeTotal, setImporteTotal] = useState(0);
    const [cuotas, setCuotas] = useState([]);
    const [vinculosCuenta, setVinculosCuenta] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [messageConfirm, setMessageConfirm] = useState({
        show: false,
        title: "",
        data: null,
        callback: null
    });


    const [tieneDeudaPlanPago, setTieneDeudaPlanPago] = useState(false);
    const [tieneDeudaLegalPlanPago, setTieneDeudaLegalPlanPago] = useState(false);
    const [debitoAutomaticoDisabled, setDebitoAutomaticoDisabled] = useState(false);
    const [convenioPreview, setConvenioPreview] = useState(null);

    useEffect(() => {
        const data = cache[params.processKey];
        if (data) { //el cache tiene datos
            setState(prevState => {
                return {...prevState, idCuenta: data.value.idCuenta, items: data.value.items};
            });
            SearchPlanPagoDefinicionCuenta(data.value.idCuenta, data.value.items);
        }
        else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, "No se pudo recuperar la información de la solicitud");
        }
    }, []);

    useEffect(() => {
        if (planPagoDefinicion.id > 0) {
            SearchPlanPagoDefinicionCuotas();
        }
        else {
            setOpcionCuotas([]);
            setCuotas([]);
            setOpcionCuotaSelected(entityInit.opcionCuota);
            setImporteTotal(precisionRound(entityInit.opcionCuota.importePlanPago+entityInit.opcionCuota.importeSellados));
            formSet({
                idTipoVinculoCuenta: 0,
                idVinculoCuenta: 0,
                idUsuarioFirmante: 0,
                aplicaDebitoAutomatico: false,
                idMedioPago: 0
            });
        }
    }, [planPagoDefinicion]);

    useEffect(() => {
        const disabled = state.disbled
            || planPagoDefinicion.idTipoTratamientoDebitoAutomatico === TRATAMIENTO_DEBITO_AUTOMATICO_TYPE.SIN_DEBITO_AUTOMATICO
            || planPagoDefinicion.idTipoTratamientoDebitoAutomatico === TRATAMIENTO_DEBITO_AUTOMATICO_TYPE.SOLO_DEBITO_AUTOMATICO;
        setDebitoAutomaticoDisabled(disabled);
    }, [planPagoDefinicion, state]);

    const [getListEntidad,] = useEntidad({
        entidades: ['TipoVinculoCuenta'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoVinculoCuenta',
            timeout: 0
        }
    });

    const [, getRowLista] = useLista({
        listas: ['TipoDocumento'],
        onLoaded: (listas, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
          key: 'TipoDocumento',
          timeout: 0
        }
    });

    const [formValues, formHandle, , formSet] = useForm({
        idTipoVinculoCuenta: 0,
        idVinculoCuenta: 0,
        idUsuarioFirmante: 0,
        aplicaDebitoAutomatico: false,
        idMedioPago: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    function getErrors() {
        const errors = {};

        if (planPagoDefinicion.id === 0) errors.planPagoDefinicion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idTipoVinculoCuenta === 0) errors.idTipoVinculoCuenta = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idVinculoCuenta === 0) errors.idVinculoCuenta = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.aplicaDebitoAutomatico && formValues.idMedioPago === 0) errors.idMedioPago = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    //definiciones
    const cellSel = (props) =>      <div className='action-check'>
                                        <input className="form-check-input" type="checkbox" value={''} checked={ opcionCuotas[props.value].selected } readOnly={true} />
                                    </div>

    const tableColumnsOpcionCuotas = [
        { Header: '', Cell: cellSel, accessor: 'index', width:'5%', disableGlobalFilter: true, disableSortBy: true},
        { Header: 'Cuotas', accessor: 'cantidadCuotas', width: '10%', alignCell: 'right', disableSortBy: true },
        { Header: 'Deuda act.', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeCapital', width: '16%', alignCell: 'right', disableSortBy: true },
        { Header: 'Intereses', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeIntereses', width: '12%', alignCell: 'right', disableSortBy: true },
        { Header: 'Sellados', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSellados', width: '12%', alignCell: 'right', disableSortBy: true },
        { Header: 'Anticipo', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAnticipo', width: '15%', alignCell: 'right', disableSortBy: true },
        { Header: 'Quita', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeQuita', width: '15%', alignCell: 'right', disableSortBy: true },
        { Header: 'Imp. cuota', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeCuota', width: '15%', alignCell: 'right', disableSortBy: true }
    ];

    const tableColumnsCuotas = [
        { Header: 'Cuota', Cell: (props) => (props.value === 0) ? "Anticipo" : props.value, accessor: 'numeroCuota', width: '12%', alignCell: 'right', disableSortBy: true },
        { Header: 'Imp. capital', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeCapital', width: '18%', alignCell: 'right', disableSortBy: true },
        { Header: 'Intereses', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeIntereses', width: '17%', alignCell: 'right', disableSortBy: true },
        { Header: 'Sellados', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSellados', width: '17%', alignCell: 'right', disableSortBy: true },
        { Header: 'Imp. final', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeCuota', width: '20%', alignCell: 'right', disableSortBy: true },
        { Header: 'Vencimiento', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaVencimiento', width: '16%', disableSortBy: true }
    ];

    //handles
    const handleClickSelected = (indexSelected) => {
        const list = [...opcionCuotas];
        for (let index=0; index < list.length; index++) {
            list[index].selected = false;
        }
        list[indexSelected].selected = true;
        const opcionCuota =  CloneObject(list[indexSelected]);

        setOpcionCuotas(list);
        setCuotas(opcionCuota.cuotas);
        setOpcionCuotaSelected(opcionCuota);
        setImporteTotal(precisionRound(opcionCuota.importePlanPago+opcionCuota.importeSellados));
    }
    const handleClickVolver = () => {
        dispatch(memoActionDel(params.processKey));
        navigate({ to: "../deuda/edit/" + cuenta.id, });
    }
    const getSolicitudPlanPago = () => {
        if (state.idCuenta === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "La cuenta no está definida");
            return;
        }
        if (!validate()) return;

        if (opcionCuotaSelected.cantidadCuotas === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "Debe seleccionar la cantidad de cuotas");
            return;
        }

        const medioPagoSelected = mediosPago.find(f => Number(f.id) === parseInt(formValues.idMedioPago));

        return {
            idCuenta: state.idCuenta,
            idPlanPagoDefinicion: planPagoDefinicion.id,
            idTipoVinculoCuenta: formValues.idTipoVinculoCuenta,
            idVinculoCuenta: formValues.idVinculoCuenta,
            cantidadCuotas: opcionCuotaSelected.cantidadCuotas,
            aplicaDebitoAutomatico: formValues.aplicaDebitoAutomatico,
            idMedioPago: formValues.idMedioPago,
            detalleMedioPago: medioPagoSelected?.detalleMedioPago ?? "",
            items: state.items
        };
    }
    const handleClickCrearPlanPago = () => {
        const data = getSolicitudPlanPago();
        if (!data) return;
        setMessageConfirm({
            show: true,
            title: "Está seguro de generar el plan de pagos",
            data: data,
            callback: (data) => AddPlanPago(data)
        });
    }
    const handleClickVistaPrevia = () => {
        const data = getSolicitudPlanPago();
        if (!data) return;
        setState(prevState => ({ ...prevState, loading: true }));
        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.REPORTE,
            '/PlanPagoConvenioPreview',
            data,
            response => response.text().then(html => {
                setConvenioPreview(html);
                setState(prevState => ({ ...prevState, loading: false }));
            }).catch(callbackError),
            callbackNoSuccess,
            callbackError
        );
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    }
    const callbackSearchPlanPagoDefinicionCuenta = (response) => {
        response.json()
        .then((data) => {
            const definiciones = data.filter(f => f.valid);
            setDefiniciones(definiciones);
            const definicionesSinRelacion = data.filter(f => !f.aplicaVinculoCuenta && f.relacionesPermitidas.length > 0 && f.observaciones.length === 1);
            setDefinicionesSinRelacion(definicionesSinRelacion);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessSearchPlanPagoDefinicionCuotas = (response) => {
        response.json()
        .then((data) => {
            if (data.opcionCuotas.length > 0) {
                data.opcionCuotas.forEach((opcionCuota, index) => {
                    opcionCuota.index = index;
                    opcionCuota.selected = (index === 0);
                });

                setTipoVinculoCuentaPermitidos(data.tiposVinculoCuenta.map(x => x.idTipoVinculoCuenta));
                setOpcionCuotas(data.opcionCuotas);
                setCuotas(data.opcionCuotas[0].cuotas);
                setOpcionCuotaSelected(data.opcionCuotas[0]);
                setImporteTotal(precisionRound(data.opcionCuotas[0].importePlanPago+data.opcionCuotas[0].importeSellados));
                setTieneDeudaPlanPago(data.tieneDeudaPlanPago && !data.tieneDeudaLegalPlanPago);
                setTieneDeudaLegalPlanPago(data.tieneDeudaLegalPlanPago);

                formSet({
                    idTipoVinculoCuenta: planPagoDefinicion.idTipoVinculoCuentaPredeterminado,
                    idVinculoCuenta: 0,
                    idUsuarioFirmante: 0,
                    aplicaDebitoAutomatico: planPagoDefinicion.idTipoTratamientoDebitoAutomatico === TRATAMIENTO_DEBITO_AUTOMATICO_TYPE.SOLO_DEBITO_AUTOMATICO,
                    idMedioPago: 0
                });
            }
            else {
                const message = 'No hay opciones disponibles para el monto seleccionado';
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            }

            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessSearchVinculoCuenta = (response) => {
        response.json()
        .then((data) => {
            setVinculosCuenta(data);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });   
    }
    const callbackSuccessSearchMediosPago = (response) => {
        response.json()
        .then((data) => {
            setMediosPago(data);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessAddPlanPago = (response) => {
        response.json()
        .then((planPago) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Plan de pagos generado correctamente");
            setState(prevState => {
                return {...prevState, loading: false, disbled: true, idPlanPago: planPago.id, showResumen: true};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    //funciones
    function SearchPlanPagoDefinicionCuenta(idCuenta, items) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = {
            items: items
        }
        const paramsUrl = `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PLAN_PAGO_DEFINICION,
            paramsUrl,
            dataBody,
            callbackSearchPlanPagoDefinicionCuenta,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchPlanPagoDefinicionCuotas() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = {
            idCuenta: state.idCuenta,
            items: state.items
        }
        const paramsUrl = `/${planPagoDefinicion.id}/cuotas`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.PLAN_PAGO_DEFINICION,
            paramsUrl,
            dataBody,
            callbackSuccessSearchPlanPagoDefinicionCuotas,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchVinculoCuenta(idTipoTributo, idTributo) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/tributo/${idTipoTributo}/${idTributo}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.VINCULO_CUENTA,
            paramsUrl,
            null,
            callbackSuccessSearchVinculoCuenta,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchMediosPago(idCuenta) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.MEDIO_PAGO,
            paramsUrl,
            null,
            callbackSuccessSearchMediosPago,
            callbackNoSuccess,
            callbackError
        );

    }
    function AddPlanPago(data) {

        setState(prevState => {
        return {...prevState, loading: true};
        });

        const dataBody = data;

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.PLAN_PAGO,
            null,
            dataBody,
            callbackSuccessAddPlanPago,
            callbackNoSuccess,
            callbackError
        );

    }
    
    const getDescTipoDocumento = (id) => {
        const row = getRowLista('TipoDocumento', id);
        return (row) ? row.nombre : '';
    }

    const getMensajeSinRelacion = () => {
        if (definicionesSinRelacion.length > 1) return 'Para aplicar un plan de pago, la cuenta necesita una persona vinculada con una relación que los convenios admitan.';
        const definicion = definicionesSinRelacion[0];
        const relacion = (definicion.relacionesPermitidas.length > 2) ? 'con una relación que el convenio admita' : `como ${definicion.relacionesPermitidas.join(' o ')}`;
        return `${definicion.descripcion.trim()} aplica a esta deuda, pero requiere una persona vinculada ${relacion}.`;
    }


    return (
    <>

        <Loading visible={state.loading}></Loading>

        {convenioPreview !== null &&
            <Modal
                title="Vista previa del convenio"
                size="xl"
                onEscape={() => setConvenioPreview(null)}
                body={<iframe title="Convenio de plan de pagos" srcDoc={convenioPreview} sandbox=""
                    style={{ width: '100%', height: '70vh', border: 0 }} />}
                footer={<button className="btn back-button" onClick={() => setConvenioPreview(null)}>Cerrar</button>}
            />
        }

        {messageConfirm.show && 
            <MessageModal
                title={"Confirmación"}
                message={messageConfirm.title}
                onDismiss={() => {
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
                onConfirm={() => {
                    if (messageConfirm.callback) {
                        messageConfirm.callback(messageConfirm.data);
                    }
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
            />
        }

        {state.showResumen && 
            <EmisionPlanPagoGrid
                idPlanPago={state.idPlanPago}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showResumen: false};
                    });
                    handleClickVolver();
                }}
            />
        }

        <SectionHeading
            titles={[
                { title: 'Tributos' },
                { title: 'Cálculo de deuda' },
                { title: 'Planes de pago', },
            ]}
        />

        <section className='section-accordion'>

            {tieneDeudaPlanPago &&
            <div className="marcador">
                <span>
                    Deuda con plan de pago caído
                    <a href='#' className="link-no-color float-end">
                        <span onClick={ () => setTieneDeudaPlanPago(false) } className="material-symbols-outlined span-close">close</span>
                    </a>
                </span>
            </div>
            }
            {tieneDeudaLegalPlanPago &&
            <div className="marcador">
                <span>
                    Deuda judicializada con plan de pago caído
                    <a href='#' className="link-no-color float-end">
                        <span onClick={ () => setTieneDeudaLegalPlanPago(false) } className="material-symbols-outlined span-close">close</span>
                    </a>
                </span>
            </div>
            }

            <div className='row form-basic m-top-10 m-bottom-20'>
                <div className="col-12 col-lg-2">
                    <label htmlFor="cuenta" className="form-label">Cuenta</label>
                    <InputCuenta
                        name="cuenta"
                        placeholder=""
                        className="form-control"
                        value={state.idCuenta}
                        onUpdate={({target}) => {
                            const cuenta = target.row;
                            if (cuenta) {
                                setCuenta(cuenta);
                                SearchVinculoCuenta(cuenta.idTipoTributo, cuenta.idTributo);
                                SearchMediosPago(cuenta.id);
                            }
                            else {
                                setCuenta(entityInit.cuenta);
                                setVinculosCuenta([]);
                                setMediosPago([]);
                            }
                        }}
                        disabled={true}
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <FormLabel htmlFor="planPagoDefinicion" required>Convenio</FormLabel>
                    <InputStaticEntidad
                        name="planPagoDefinicion"
                        placeholder=""
                        className={`form-control ${errorOf('planPagoDefinicion') ? 'is-invalid' : ''}`}
                        value={planPagoDefinicion.id}
                        title="Convenio"
                        onChange={({target}) => {
                            const definicion = target.row;
                            if (definicion) {
                                setPlanPagoDefinicion(definicion);
                            }
                            else {
                                setPlanPagoDefinicion(entityInit.planPagoDefinicion);
                            }
                        }}
                        onFormat={(row) => (row && row.id)
                                            ? (row.tipoPlanPago.convenio.length > 0)
                                                ? `${row.descripcion} (Convenio: ${row.tipoPlanPago.convenio})`
                                                : row.descripcion
                                            : ''}
                        columns={[
                            { Header: 'Código', accessor: 'codigo', width: '25%' },
                            { Header: 'Descripción', accessor: 'descripcion', width: '70%' }
                        ]}
                        list={definiciones}
                        disabled={state.disbled || (definiciones.length === 0 && definicionesSinRelacion.length > 0)}
                    />
                    <FormError message={errorOf('planPagoDefinicion')} />
                </div>
                {(definiciones.length === 0 && definicionesSinRelacion.length > 0) &&
                <div className="col-12 d-flex align-items-center gap-2">
                    <span className="busqueda-mensaje">
                        <span className="material-symbols-outlined" aria-hidden="true">warning</span>
                        {getMensajeSinRelacion()}
                    </span>
                </div>
                }
            </div>

            {planPagoDefinicion.id > 0 &&
            <div className='row'>

                <div className="col-12 col-lg-6">

                    <div className='row'>
                        <div className="col-12">
                            <label className="form-label">Opciones disponibles</label>
                            <TableCustom
                                showFooter={false}
                                showFilterGlobal={false}
                                floatingDownloadCSVButton={true}
                                className={'TableCustomBase'}
                                columns={tableColumnsOpcionCuotas}
                                data={opcionCuotas}
                                onClickRow={(row, cellId) => {
                                    if (cellId !== "abm" && !state.disbled) {
                                        handleClickSelected(row.index);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="col-12 col-lg-6">

                    <div className='row'>
                        <div className="col-12">
                            <label className="form-label">Cuotas del plan de pagos</label>
                            <TableCustom
                                showFooter={false}
                                showFilterGlobal={false}
                                floatingDownloadCSVButton={true}
                                className={'TableCustomBase'}
                                columns={tableColumnsCuotas}
                                data={cuotas}
                            />
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className="col-12 col-lg-6 m-top-10">
                        <FormLabel htmlFor="idTipoVinculoCuenta" required>Relación</FormLabel>
                        <Select
                            name="idTipoVinculoCuenta"
                            className={`form-control ${errorOf('idTipoVinculoCuenta') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoVinculoCuenta}
                            options={getListEntidad('TipoVinculoCuenta').filter(f => tipoVinculoCuentaPermitidos.includes(f.id) && vinculosCuenta.some(x => x.idTipoVinculoCuenta === f.id)).map(item => ({ value: item.id, label: item.nombre }))}
                            onChange={({target}) => {
                                formSet({...formValues, idTipoVinculoCuenta: target.value, idVinculoCuenta: 0});
                            }}
                            disabled={state.disbled}
                        />
                        <FormError message={errorOf('idTipoVinculoCuenta')} />
                    </div>
                    <div className="col-12 col-lg-6 m-top-10">
                        <FormLabel htmlFor="idVinculoCuenta" required>Solicitante</FormLabel>
                        <Select
                            name="idVinculoCuenta"
                            className={`form-control ${errorOf('idVinculoCuenta') ? 'is-invalid' : ''}`}
                            value={formValues.idVinculoCuenta}
                            options={vinculosCuenta.filter(f => f.idTipoVinculoCuenta === formValues.idTipoVinculoCuenta).map(item => ({ value: item.id, label: `${item.nombrePersona} (${getDescTipoDocumento(item.idTipoDocumento)} ${item.numeroDocumento})` }))}
                            onChange={formHandle}
                            disabled={state.disbled || !vinculosCuenta.some(f => f.idTipoVinculoCuenta === formValues.idTipoVinculoCuenta)}
                        />
                        <FormError message={errorOf('idVinculoCuenta')} />
                    </div>
                </div>

                <div className='row m-top-10'>
                    <div className="col-12 col-lg-6">
                        <CheckboxButtonGroup>
                            <CheckboxButton
                                name="aplicaDebitoAutomatico"
                                label="Aplica débito automático"
                                checked={formValues.aplicaDebitoAutomatico}
                                onChange={({target}) => {
                                    formSet({...formValues, aplicaDebitoAutomatico: target.checked, idMedioPago: 0});
                                }}
                                disabled={debitoAutomaticoDisabled}
                            />
                        </CheckboxButtonGroup>
                    </div>
                    { formValues.aplicaDebitoAutomatico &&
                        <div className="col-12 col-lg-6">
                            <FormLabel htmlFor="idMedioPago" required>Medio de pago</FormLabel>
                            <Select
                                name="idMedioPago"
                                className={`form-control ${errorOf('idMedioPago') ? 'is-invalid' : ''}`}
                                value={formValues.idMedioPago}
                                options={mediosPago.map(item => ({ value: item.id, label: item.detalleMedioPago }))}
                                onChange={formHandle}
                                disabled={state.disbled}
                            />
                            <FormError message={errorOf('idMedioPago')} />
                        </div>
                    }
                </div>

                <div className='row m-top-10'>
                    <div className="col-12 col-lg-2">
                        <label htmlFor="importeCapital" className="form-label">Deuda actualizada</label>
                        <InputNumber
                            name="importeCapital"
                            placeholder=""
                            className="form-control"
                            value={ opcionCuotaSelected.importeCapital }
                            precision={2}
                            disabled={true}
                        />
                    </div>
                    <div className="col-12 col-lg-2">
                        <label htmlFor="importeQuita" className="form-label">(-) Total quita</label>
                        <InputNumber
                            name="importeQuita"
                            placeholder=""
                            className="form-control"
                            value={ opcionCuotaSelected.importeQuita }
                            precision={2}
                            disabled={true}
                        />
                    </div>
                    <div className="col-12 col-lg-2">
                        <label htmlFor="importeIntereses" className="form-label">(+) Total intereses</label>
                        <InputNumber
                            name="importeIntereses"
                            placeholder=""
                            className="form-control"
                            value={ opcionCuotaSelected.importeIntereses }
                            precision={2}
                            disabled={true}
                        />
                    </div>
                    <div className="col-12 col-lg-2">
                        <label htmlFor="importePlanPago" className="form-label">Monto plan de pagos</label>
                        <InputNumber
                            name="importePlanPago"
                            placeholder=""
                            className="form-control"
                            value={ opcionCuotaSelected.importePlanPago }
                            precision={2}
                            disabled={true}
                        />
                    </div>
                    <div className="col-12 col-lg-2">
                        <label htmlFor="importeSellados" className="form-label">(+) Sellados</label>
                        <InputNumber
                            name="importeSellados"
                            placeholder=""
                            className="form-control"
                            value={ opcionCuotaSelected.importeSellados }
                            precision={2}
                            disabled={true}
                        />
                    </div>
                    <div className='row m-top-10'>
                        <div className="col-12 col-lg-4">
                            <label htmlFor="importeTotal" className="form-label">Monto total</label>
                            <InputNumber
                                name="importeTotal"
                                placeholder=""
                                className="form-control"
                                value={ importeTotal }
                                precision={2}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>

            </div>
            }

        </section>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn back-button float-start" onClick={ (event) => handleClickVolver() }>Volver</button>
                {!state.disbled &&
                <>
                    <button className="btn action-button float-end m-left-10" disabled={state.loading || (definiciones.length === 0 && definicionesSinRelacion.length > 0)} onClick={ (event) => handleClickCrearPlanPago() }>Crear plan de pagos</button>
                    <button className="btn back-button float-end m-left-10" disabled={state.loading || (definiciones.length === 0 && definicionesSinRelacion.length > 0)} onClick={handleClickVistaPrevia}>Vista previa del convenio</button>
                </>
                }
            </div>
        </footer>
        
    </>
    )
}

export default PlanPagoView;
